/**
 * Позиция инспектора для блока «Расстояние / ETA» в карточке заказа.
 *
 * Источник: view `public.inspector_position_for_dealer` (миграция
 * `20260504000000_geo_phase1.sql`). View доступна:
 *   - admin / dispatcher
 *   - manager-создатель активного заказа (`o.manager_id = auth.uid()`).
 * customer_supervisor по решению фазы 1 — не видит.
 */
import { createClient } from '@/api/supabase'

export interface InspectorPositionForOrder {
  inspector_id: string
  inspector_full_name: string | null
  last_lat: number | null
  last_lon: number | null
  last_position_at: string | null
}

/**
 * Возвращает позицию инспектора, назначенного на заказ. null — если заказ
 * не активный, инспектор не назначен или у пользователя нет доступа.
 */
export async function getInspectorPositionForOrder(
  orderId: string,
): Promise<InspectorPositionForOrder | null> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('inspector_position_for_dealer')
    .select(
      'inspector_id, inspector_full_name, last_lat, last_lon, last_position_at',
    )
    .eq('order_id', orderId)
    .maybeSingle()
  if (error) throw new Error(error.message)
  return (data as InspectorPositionForOrder | null) ?? null
}
